import { Typography } from "@/design-system/Atoms";
import PrivacyPolicyLayout from "./PrivacyPolicyLayout";
import { privacyPolicyData } from "./privacyPolicy.data";

export const PrivacyPolicyTemplate = () => {
  
  return (
    <>
      <section className="contact-form bg-white">
        <div className="container mx-auto px-4">
          <Typography variant="sectionDescriptionLarge" as="p" className="mb-1">
            Privacy Policy
          </Typography>

          {privacyPolicyData.map((section, idx) => (
            <div className="mb-8" key={idx}>
              <PrivacyPolicyLayout
                heading={section.heading}
                content={section.content}
                className="mb-1"
              />
            </div>
          ))} 
        </div>
      </section>
    </>
  );
};
export default PrivacyPolicyTemplate;
